



















































import { Vue, Prop, Component } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {}
})
export default class SwiperPubBidding extends Vue {
  @Prop()
  rightNew!: any;
  @Prop()
  leftNew!: any;
  @Prop()
  jump!: any;
  @Prop()
  zt!: any;

  url = "https://www.zj-huawei.com";
  showImg = true;
  changeTime(time: string) {
    return moment(time).format("YYYY-MM-DD");
  }
}
